import type { FaireProductEntity } from "../../entity_types/product";

export const p_8yvsj6c6e8: FaireProductEntity = {
  token: "p_8yvsj6c6e8",
  type: "product",
  name: "Frozen Cocktail Display (Empty)",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/741437c2d16e0a249637530bdc88875c2d5ab60ba8eeaa3af7313e370e075487.png",
  galleryImageUrls: [],
  priceDollars: 55,
  description:
    "Frozen Cocktail Display (Empty) Available for FREE when purchasing our Frozen Cocktail Display Package.\n\nSeriously don't pay for this!  We will give it to you for FREE when its filled. Can also add this to your order with 72 packs (12 6-packs) of FROZEN cocktails only and we will adjust the order and give it to you for free!\n",
  tags: [],
  msrpDollars: 110,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:08:59.212Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
